import * as msal from '@azure/msal-browser';
import { UserSession } from 'common';
import { AuthService } from './AuthService';
import { getDeviceInfoUtil } from '../utils/deviceUtils';

export class MicrosoftService {
  static async createMsalClient() {
    console.log(`redirectUri: ${globalThis.ccFrontEndUrl}/microsoft-callback`);
    return msal.createStandardPublicClientApplication({
      auth: {
        clientId: `${globalThis.msClientId}`,
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: `${globalThis.ccFrontEndUrl}/microsoft-callback`,
      },
      cache: {
        cacheLocation: 'localStorage',
      },
      system: {
        loggerOptions: {
          logLevel: msal.LogLevel.Verbose,
          piiLoggingEnabled: false,
          loggerCallback: (level, message, containsPii) => {
            console.log(message);
          },
        },
      },
    });
  }

  static async handleRedirect() {
    console.log('handleRedirect: ', window.location.href);
    const msalClient = await MicrosoftService.createMsalClient();
    const response = await msalClient.handleRedirectPromise();
    if (response) {
      msalClient.setActiveAccount(response.account);
      await MicrosoftService.sendMicrosoftTokenToBackend(response);
    } else {
      throw new Error('No redirect response from Microsoft login.');
    }
  }

  static async sendMicrosoftTokenToBackend(result: msal.AuthenticationResult): Promise<UserSession> {
    if (!result.idToken) throw new Error('Missing idToken in response');
    const res = await fetch(`${globalThis.ccLambdaBaseUrl}/fn/microsoft/validate-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: result.idToken, deviceInfo: getDeviceInfoUtil() }),
    });
    const response = await res.json();
    if (!res.ok) throw new Error(response.message || 'Failed to validate Microsoft session');
    AuthService.setSessionData(response);
    return response;
  }
}
